import { render, staticRenderFns } from "./mallBanner.vue?vue&type=template&id=d08a3516&scoped=true&"
import script from "./mallBanner.vue?vue&type=script&lang=js&"
export * from "./mallBanner.vue?vue&type=script&lang=js&"
import style0 from "./mallBanner.vue?vue&type=style&index=0&id=d08a3516&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08a3516",
  null
  
)

export default component.exports